import type { PaymentErrorModel } from '@core/analytics/common/models/mixpanel.model';
import { describeExpectedFailure, listCauseChain } from '../../../analytics/app/common/sentry/sentryEvent';
import {
  CODE_DEFECT_ERROR_NAMES,
  CODE_DEFECT_FAILURE_CODES,
  SDK_MISUSE_MESSAGES,
  USER_CANCELLED_STATUS_CODE,
} from '../constants/paymentCodes';

export function isCodeDefect(error: unknown): boolean {
  if (typeof error === 'string') {
    return CODE_DEFECT_FAILURE_CODES.has(error);
  }

  if (describeExpectedFailure(error)) {
    return false;
  }

  return listCauseChain(error).some((link) => {
    const message = typeof link.message === 'string' ? link.message : '';

    return (link instanceof Error && CODE_DEFECT_ERROR_NAMES.has(link.name))
      || SDK_MISUSE_MESSAGES.some(snippet => message.includes(snippet));
  });
}

export function isUserCancellation(error?: PaymentErrorModel['error']): boolean {
  return typeof error !== 'string' && error?.statusCode === USER_CANCELLED_STATUS_CODE;
}
